import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import '../../Project.less';
import { Tabs, Tab } from '../../../components/Tabs';
import TabDescription from './Tabs/TabDescription';
import TabTeamPolicies from '../../../components/strategyProject/tabs/TabTeamPolicies';
import ProjectRegister from '../../../components/common/Profile/Tabs/ProjectRegister';
import BackBtn from '../../../components/UI/BackBtn';
import useUserContext from '../../../hooks/useUserContext';
import useAPI from '../../../hooks/useAPI';
import useNavProject from '../../../hooks/useNavProject';

export default function PolicyProfilePage() {
  const { stratId } = useParams();
  const userCtx = useUserContext();
  const api = useAPI();

  const navProject = useNavProject();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [policy, setPolicy] = useState([]);
  const tabs = [
    { label: 'description', tabName: 'Политика', content: <TabDescription data={policy} /> },
    {
      label: 'team', tabName: 'Команда управления', hide: (policy) => !policy?.isPortfolio, content: <TabTeamPolicies data={policy} />,
    },
    {
      label: 'subprojectconnection', tabName: 'Реестр проектов цифровой трансформации', hide: (policy) => !policy?.isPortfolio, content: <ProjectRegister data={policy} />,
    },
  ];

  useEffect(async () => {
    try {
      const result = await api.get(`/info/strategies/${stratId}`);
      navProject.setPolicyTitle(result.name);
      navProject.setPolicyIsPortfolio(result.isPortfolio)
      setPolicy(result);
      setIsLoaded(true);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  }, []);

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page projects-page"><div className="container"><div>Загрузка...</div></div></section>;
  }
  return (
    <section className="page project-page">
      <div className="container">
        <BackBtn />
        <section className="page project-page">
          <div className="project-title-wrapper">
            <h3>{policy.name}</h3>
          </div>
          <Tabs>
            {tabs
              .filter((tab) => !tab.hide || !tab.hide(policy, userCtx.perms))
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  {tab.content}
                </Tab>
              ))}
          </Tabs>
        </section>
      </div>
    </section>
  );
}
